export default {
  PAGE_SIZE: 10,
  HISTORY_DATE_FORMAT: 'MMMM D, YYYY',
};
